import React from "react";
import PDFPage from "../../../themed/pdf/pdfPage";
import PDFGraphPage from "./pdfGraphPage";
import PDFTablePage from "../../../themed/pdf/pdfTablePage";

import * as data from "../../../../utils/data";
import * as models from "../../../../utils/models";
import * as utils from "../../../../utils/utilities";

interface HelideckAnalysisProps {
  dryTableData: any[];
  wetTableData: any[];
  projectDetails: models.Project;
}

const HelideckAnalysis = (props: HelideckAnalysisProps) => {
  const columns: models.Column[] = data.getHelideckFrictionTableColumns();
  const chunkedDryTableData = utils.getChunkedData(props.dryTableData, 15);
  const chunkedWetTableData = utils.getChunkedData(props.wetTableData, 15);

  const chunkedDryGraphData = chunkedDryTableData.map((d: any[]) => {
    return data.getHelideckLineGraphData(d);
  });

  const chunkedWetGraphData = chunkedWetTableData.map((d: any[]) => {
    return data.getHelideckLineGraphData(d);
  });

  return (
    <React.Fragment>
      {chunkedDryTableData.map((data, index: number) => (
        <PDFPage
          key={index.toString()}
          enableTitlePage={index === 0}
          projectDetails={props.projectDetails}
          pageDetails={utils.getPageDetails(
            `Data Sheet - ${index + 1}`,
            "Dry Condition"
          )}
        >
          <PDFTablePage data={data} columns={columns} />
        </PDFPage>
      ))}

      {chunkedDryGraphData.map((data: any, index: number) => (
        <PDFPage
          key={index.toString()}
          enableTitlePage={index === 0}
          projectDetails={props.projectDetails}
          pageDetails={utils.getPageDetails(
            `Graph Sheet - ${index + 1}`,
            "Dry Condition"
          )}
        >
          <PDFGraphPage data={data} />
        </PDFPage>
      ))}

      {chunkedWetTableData.map((data, index: number) => (
        <PDFPage
          key={index.toString()}
          enableTitlePage={index === 0}
          projectDetails={props.projectDetails}
          pageDetails={utils.getPageDetails(
            `Data Sheet - ${index + 1}`,
            "Wet Condition"
          )}
        >
          <PDFTablePage data={data} columns={columns} />
        </PDFPage>
      ))}

      {chunkedWetGraphData.map((data: any, index: number) => (
        <PDFPage
          key={index.toString()}
          enableTitlePage={index === 0}
          projectDetails={props.projectDetails}
          pageDetails={utils.getPageDetails(
            `Graph Sheet - ${index + 1}`,
            "Wet Condition"
          )}
        >
          <PDFGraphPage data={data} />
        </PDFPage>
      ))}
    </React.Fragment>
  );
};

export default HelideckAnalysis;
